import React from 'react'
import ContentLoader from 'react-content-loader'

const Loader = () => {
  const body = new Array(5).fill(null).map((i, ind) => {
    const yStrip = 99 + (68 * ind)
    return (
      <React.Fragment key={ind}>
        {
          <>
            <rect x='30' y={yStrip} rx='3' ry='3' width='12' height='8' />
            <rect x='50' y={yStrip} rx='3' ry='3' width='130' height='14' />
            <rect x='1320' y={yStrip} rx='3' ry='3' width='120' height='14' />
          </>
        }
      </React.Fragment>
    )
  })
  return (
    <ContentLoader
      speed={2}
      width={1464}
      height={400}
      viewBox='0 0 1464 400'
      backgroundColor='#f3f3f3'
      foregroundColor='#ecebeb'
    >
      <rect x='14' y='48' rx='3' ry='3' width='90' height='12' />
      {body}
    </ContentLoader>
  )
}

export default Loader